/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { isTouch } from './clientUtils';

/**
 * The default offset for datatip mainAxis.
 */
export const DATATIP_OFFSET = isTouch() ? 20 : 8;
